import { sessionStorageKeys } from "imagineplus-assessments/types";
import { useCallback } from "react";

export default function useMyPathReferrer() {
  const returnToMyPathLandingPage = useCallback(() => {
    sessionStorage.removeItem(sessionStorageKeys.referrer);
    sessionStorage.setItem("target", "MyPath");
    // IMPORTANT: this route is not in the react-router routes yet, so we must use window.location.replace
    window.location.replace("/liftoff");
  }, []);

  return { returnToMyPathLandingPage };
}
